import {
    UPI_DEEPLINK_TYPE,
} from 'entities/payment-methods/constants';

import gpayImage from '../media/gpay.svg';
import paytmImage from '../media/paytm.svg';
import phonepeImage from '../media/phonepe.svg';
import upiImage from '../media/upi.svg';

export function formatIcon(type: UPI_DEEPLINK_TYPE): string {
    switch (type) {
        case UPI_DEEPLINK_TYPE.UPI: {
            return upiImage;
        }
        case UPI_DEEPLINK_TYPE.PAYTM: {
            return paytmImage;
        }
        case UPI_DEEPLINK_TYPE.PHONEPE: {
            return phonepeImage;
        }
        case UPI_DEEPLINK_TYPE.GPAY: {
            return gpayImage;
        }
    }
}
